import { create } from "zustand";
import { useEmails } from "../../useEmails";
import moment from "moment";
import api from "../../../../../api";

export let useEmailsHeader = create((set, get) => ({
  filter: {
    vesselId: "*",
    department: "*",
    userId: "*",
    date: new Date(),
    status: "*",
    dueDate: "*",
    dueDateRange: "*",
    from: moment()
      .utc()
      .subtract(3, "month")
      //.subtract(90, "day")
      //.startOf("month")
      .startOf("day")
      .toDate(),
    to: moment().utc().add(1, "day").endOf("day").toDate(),
  },

  searchValues: {
    invoiceId: undefined,
    invoiceNumber: undefined,
    purchaseOrderNumber: undefined,
  },

  overdueInvoices: null,
  dueIn7Days: null,
  latestSearchRequest: null,

  vesselHandler: (value) => {
    // let { getLocationById } = frontDB.getState();
    // const vesselName = getLocationById(vesselId).name;
    // set({ searchValues: { ...get().searchValues, vesselName } });
    set({ filter: { ...get().filter, vesselId: value } });
  },

  userHandler: (value) => {
    set({ filter: { ...get().filter, userId: value } });
  },

  statusHandler: (value) => {
    set({ filter: { ...get().filter, status: value } });
  },

  departmentHandler: (value) => {
    set({ filter: { ...get().filter, department: value } });
  },

  searchInputHandler: (value, e) => {
    let { getInvoices, setTableLoading } = useEmails.getState();

    setTableLoading(true);

    let { searchValues, latestSearchRequest } = get();
    let id = e.target.id;

    set({ searchValues: { ...searchValues, [id]: value } });

    //console.log(searchValues);
    if (latestSearchRequest) {
      clearTimeout(latestSearchRequest);
    }

    latestSearchRequest = setTimeout(() => {
      useEmails.setState({ activePage: 1 });
      getInvoices();
      setTableLoading(false);
    }, 500);

    set({ latestSearchRequest });
  },

  searchClearHandler: (id) => {
    let { getInvoices, setTableLoading } = useEmails.getState();
    setTableLoading(true);
    let { searchValues, latestSearchRequest } = get();
    set({ searchValues: { ...searchValues, [id]: "" } });
    if (latestSearchRequest) {
      clearTimeout(latestSearchRequest);
    }
    latestSearchRequest = setTimeout(() => {
      useEmails.setState({ activePage: 1 });
      getInvoices();
      setTableLoading(false);
    }, 500);
    set({ latestSearchRequest });
  },

  handleClearCompany: () => {
    let { searchValues, latestSearchRequest } = get();
    set({ searchValues: { ...searchValues, company: undefined } });
    if (latestSearchRequest) {
      clearTimeout(latestSearchRequest);
    }
  },
  periodFromHandler: (v, e) => {
    if (!v) return;
    let from = moment(v).utc().startOf("day").format();
    set({ filter: { ...get().filter, from } });
  },

  periodToHandler: (v, e) => {
    if (!v) return;
    let to = moment(v).utc().endOf("day").format();
    set({ filter: { ...get().filter, to } });
    console.log(get().filter);
  },

  dueDateHandler: (value) => {
    let fromDate = moment().utc().startOf("day").format(); //.toDate()

    let dueDate = value;
    if (value == "Overdue") dueDate = fromDate;
    if (value == "1 day") dueDate = moment(fromDate).utc().add(1, "d").format();
    if (value == "3 days")
      dueDate = moment(fromDate).utc().add(3, "d").format();
    if (value == "7 days")
      dueDate = moment(fromDate).utc().add(7, "d").format();
    if (value == "14 days")
      dueDate = moment(fromDate).utc().add(14, "d").format();

    console.log("dueDate: " + dueDate);
    set({ filter: { ...get().filter, dueDateRange: value, dueDate } });
  },

  getDueData: async () => {
    let response = await api.invoices.getDueInvoiceCounts();

    let { overdueInvoices, dueIn7Days } = response;

    set({ overdueInvoices, dueIn7Days });
  },
}));

const unsubscribe = useEmailsHeader.subscribe((newState, prevState) => {
  if (prevState.filter !== newState.filter) {
    useEmails.setState({ activePage: 1 });
    useEmails.getState().getEmails();
  }
});
